import { AppI18nConfig } from './types';
export async function getAppI18nConfig(appName: string): Promise<AppI18nConfig> {
	try {
    	const config = require(`apps/${appName}/app.config.js`);
		return config.appI18nConfig;
	} catch(err) {
		console.warn(`[i18n] No config found for app "${appName}". Falling back to default.`);
		console.warn(err)
		return {
			defaultLocale: 'en',
			supportedLocales: ['en'],
		};
	}
}